import React from 'react';
import { Row, Col, Skeleton } from 'antd';
import Wrapper from './style';

const Index = (props) => {
  const {
    title,
    total = 0,
    icon,
    isLoading,
    cursor = 'default',
    onClick,
    color = 'purple',
  } = props;

  return (
    <Wrapper
      cursor={cursor}
      onClick={() => {
        if (onClick) onClick();
      }}
      color={color}
    >
      <Skeleton
        avatar={{ size: 52 }}
        loading={isLoading}
        title={{ style: { marginTop: 4 } }}
        paragraph={{ rows: 1, style: { marginTop: 16, marginBottom: 4 } }}
      >
        <Row gutter={24}>
          <Col span={6}>
            <div className="component_recap_card_icon_wrapper">{icon}</div>
          </Col>
          <Col span={18}>
            <div className="font-header3_medium black2">{total}</div>
            <div className="font-paragraph_medium black4">{title}</div>
          </Col>
        </Row>
      </Skeleton>
    </Wrapper>
  );
};

export default Index;
